export default "__VITE_ASSET__m$XQHAQR__"